/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon32Regular = forwardRef('ArrowDCornerRightUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M29.707 12.293a1 1 0 0 1-1.414 1.414L21 6.414V22a5 5 0 0 1-5 5H4a1 1 0 1 1 0-2h12a3 3 0 0 0 3-3V6.414l-7.293 7.293a1 1 0 0 1-1.414-1.414l7.338-7.338a3.35 3.35 0 0 1 4.738 0l7.338 7.338Z" })));
});
